import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

const ChatLoader = (props: IContentLoaderProps) => {
  return (
    <ContentLoader
      speed={2}
      width="320px" // Let it fill parent width
      height={700} // Fixed rendered height
      viewBox="0 0 350 700" // Numeric viewBox
      preserveAspectRatio="xMinYMin meet" // Anchor shapes to top-left
      backgroundColor="#00000017"
      foregroundColor="#00000030"
      {...props}
    >
      {/* 
        LEFT COLUMN (approx. 320px width)
      */}
      <rect x="10" y="20" rx="20" ry="20" width="320" height="80" />
      <rect x="10" y="110" rx="20" ry="20" width="320" height="80" />
      <rect x="10" y="200" rx="20" ry="20" width="320" height="80" />
      <rect x="10" y="290" rx="20" ry="20" width="320" height="80" />
      <rect x="10" y="380" rx="20" ry="20" width="320" height="80" />
      <rect x="10" y="470" rx="20" ry="20" width="320" height="80" />
    </ContentLoader>
  );
};

export default ChatLoader;
